import React, { useEffect, useState } from "react";
import { Outlet } from "react-router-dom";

import Header from "../Header/Header";
import Sidebar from "../Sidebar/Sidebar";
import { PageType } from "../../../types/Page";
import { useAuth } from "../../../resources/AuthProvider";

import styles from "./Layout.module.css";

type LayoutProps = {
  pages: PageType[];
};

const Layout = ({ pages }: LayoutProps) => {
  const { isAuthenticated } = useAuth();

  const getIsMobile = () => window.innerWidth < 768;
  const getInitialSidebarOpen = () => {
    if (getIsMobile()) {
      return false;
    }

    const savedState = localStorage.getItem("sidebarOpen");
    return savedState ? JSON.parse(savedState) : true;
  };

  const [sidebarOpen, setSidebarOpen] = useState(getInitialSidebarOpen);
  const [isMobile, setIsMobile] = useState(getIsMobile);

  useEffect(() => {
    const handleResize = () => setIsMobile(getIsMobile());
    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    if (isMobile) {
      setSidebarOpen(false);
      return;
    }

    const savedState = localStorage.getItem("sidebarOpen");
    if (savedState) {
      setSidebarOpen(JSON.parse(savedState));
    } else {
      setSidebarOpen(true);
    }
  }, [isMobile]);

  useEffect(() => {
    if (!isMobile) {
      localStorage.setItem("sidebarOpen", JSON.stringify(sidebarOpen));
    }
  }, [sidebarOpen, isMobile]);

  if (!isAuthenticated()) {
    return <Outlet />;
  }

  return (
    <div className={styles.app}>
      <Sidebar
        open={sidebarOpen}
        pages={pages}
        mobile={isMobile}
        onCloseMobile={() => setSidebarOpen(false)}
      />

      <div className={styles.container}>
        <Header onToggleSidebar={() => setSidebarOpen(!sidebarOpen)} isMobile={isMobile} />

        <main className={styles.content}>
          <Outlet />
        </main>
      </div>
    </div>
  );
};

export default Layout;
